var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8532 4.64627C12.8997 4.6927 12.9365 4.74784 12.9617 4.80854C12.9869 4.86924 12.9998 4.9343 12.9998 5C12.9998 5.0657 12.9869 5.13076 12.9617 5.19146C12.9365 5.25215 12.8997 5.3073 12.8532 5.35373L8.35342 9.85348C8.30697 9.89993 8.25182 9.93678 8.19113 9.96192C8.13044 9.98706 8.06539 10 7.99969 10C7.934 10 7.86895 9.98706 7.80826 9.96192C7.74756 9.93678 7.69241 9.89993 7.64596 9.85348C7.59951 9.80703 7.56266 9.75188 7.53752 9.69119C7.51238 9.63049 7.49944 9.56544 7.49944 9.49975C7.49944 9.43406 7.51238 9.369 7.53752 9.30831C7.56266 9.24762 7.59951 9.19247 7.64596 9.14602L11.2926 5.49997H0.499972C0.367371 5.49997 0.240201 5.4473 0.146438 5.35353C0.0526755 5.25977 0 5.1326 0 5C0 4.8674 0.0526755 4.74023 0.146438 4.64647C0.240201 4.5527 0.367371 4.50003 0.499972 4.50003H11.2926L7.64596 0.85398C7.55215 0.760165 7.49944 0.632925 7.49944 0.50025C7.49944 0.367576 7.55215 0.240335 7.64596 0.14652C7.73978 0.0527047 7.86702 9.88503e-10 7.99969 0C8.13237 -9.88504e-10 8.25961 0.0527047 8.35342 0.14652L12.8532 4.64627Z",
    fill: "#4042E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a3acb5e6edcfc60c0d485f7978c2d264.svg";
export { ForwardRef as ReactComponent };